module.exports = __webpack_public_path__ + "../resources/img/ic_cs.17ac64a8.svg";